var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPurpleCloseIcon = function SvgPurpleCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.861669 0.147839C0.66455 -0.0492797 0.344958 -0.0492797 0.147839 0.147839C-0.04928 0.344958 -0.0492794 0.664551 0.147839 0.86167L7.28625 8.00008L0.147942 15.1384C-0.0491772 15.3355 -0.0491771 15.6551 0.147942 15.8522C0.34506 16.0493 0.664654 16.0493 0.861773 15.8522L8.00008 8.71391L15.1383 15.8521C15.3354 16.0492 15.655 16.0492 15.8521 15.8521C16.0492 15.655 16.0492 15.3354 15.8521 15.1383L8.71391 8.00008L15.8522 0.861777C16.0493 0.664658 16.0493 0.345065 15.8522 0.147947C15.6551 -0.0491722 15.3355 -0.0491716 15.1384 0.147947L8.00008 7.28625L0.861669 0.147839Z",
    fill: "#6371DE"
  })));
};
export default SvgPurpleCloseIcon;